import { lazy } from "react";
import Loadable from "app/components/Loadable";
import { ProtectedRoute } from "app/auth/ProtectedRoute";
import GenerateReferal from "../referal/GenerateReferal";

const AppForm = Loadable(lazy(() => import("./forms/AppForm")));
const AppMenu = Loadable(lazy(() => import("./menu/AppMenu")));
const AppIcon = Loadable(lazy(() => import("./icons/AppIcon")));
const AppProgress = Loadable(lazy(() => import("./AppProgress")));
const AppRadio = Loadable(lazy(() => import("./radio/AppRadio")));
const AppTable = Loadable(lazy(() => import("./tables/AppTable")));
const AppSwitch = Loadable(lazy(() => import("./switch/AppSwitch")));
const AppSlider = Loadable(lazy(() => import("./slider/AppSlider")));
const AppDialog = Loadable(lazy(() => import("./dialog/AppDialog")));
const AppButton = Loadable(lazy(() => import("./buttons/AppButton")));
const AppCheckbox = Loadable(lazy(() => import("./checkbox/AppCheckbox")));
const AppSnackbar = Loadable(lazy(() => import("./snackbar/AppSnackbar")));
const AppAutoComplete = Loadable(lazy(() => import("./auto-complete/AppAutoComplete")));
const AppExpansionPanel = Loadable(lazy(() => import("./expansion-panel/AppExpansionPanel")));
const Enquiry = Loadable(lazy(() => import("../enquiry")));
const ViewEnquiry = Loadable(lazy(() => import("../enquiry/view-enquiry")));
const Blogs = Loadable(lazy(() => import("../blog")));
const AddBlog = Loadable(lazy(() => import("../blog/add-blog")));
const Careers = Loadable(lazy(() => import("../careers")));
const AddCareer = Loadable(lazy(() => import("../careers/add-career")));
const Meta = Loadable(lazy(() => import("../meta-info")));
const AddMeta = Loadable(lazy(() => import("../meta-info/add-meta")));
const FAQ = Loadable(lazy(() => import("../faq")));
const AddFAQ = Loadable(lazy(() => import("../faq/add-faq")));
const EditFAQ = Loadable(lazy(() => import("../faq/add-faq")));
const Referals = Loadable(lazy(() => import("../referal")))
const ReferalsData = Loadable(lazy(() => import("../referaldata")))

const materialRoutes = [
  { path: "/material/table", element: <AppTable /> },
  { path: "/material/form", element: <AppForm /> },
  { path: "/material/buttons", element: <AppButton /> },
  { path: "/material/icons", element: <AppIcon /> },
  { path: "/material/progress", element: <AppProgress /> },
  { path: "/material/menu", element: <AppMenu /> },
  { path: "/material/checkbox", element: <AppCheckbox /> },
  { path: "/material/switch", element: <AppSwitch /> },
  { path: "/material/radio", element: <AppRadio /> },
  { path: "/material/slider", element: <AppSlider /> },
  { path: "/material/autocomplete", element: <AppAutoComplete /> },
  { path: "/material/expansion-panel", element: <AppExpansionPanel /> },
  { path: "/material/dialog", element: <AppDialog /> },
  { path: "/material/snackbar", element: <AppSnackbar /> },
  {
    path: "/enquiry", element: <Enquiry />
  },
  { path: "/enquiry/view-enquiry/:id", element: <ViewEnquiry /> },
  { path: "/blog", element: <Blogs /> },
  { path: "/blog/add-blog", element: <AddBlog /> },
  { path: "/blog/edit-blog/:id", element: <AddBlog /> },
  { path: "/careers/", element: <Careers /> },
  { path: "/careers/add-career", element: <AddCareer /> },
  { path: "/careers/edit-career/:id", element: <AddCareer /> },
  { path: "/meta-info", element: <Meta /> },
  { path: "/meta-info/add", element: <AddMeta /> },
  { path: "/meta-info/edit/:id", element: <AddMeta /> },
  { path: "/faq", element: <FAQ /> },
  { path: "/faq/add-faq", element: <AddFAQ /> },
  { path: "/faq/edit-faq/:id", element: <EditFAQ /> },
  { path: "/referals", element: <Referals /> },
  { path: "/referals/generate", element: <GenerateReferal /> },
  { path: "/referals/view-referal/:id", element: <GenerateReferal /> },
  { path: "/referal-data", element: <ReferalsData /> }
];

export default materialRoutes;
